import styled from 'styled-components';

export const Label = styled.p`
  text-align: left;
  margin: 0px;
  @media (max-width: 1030px) {
    font-size: 9pt;
  }
`;

export const InputContain = styled.section`
  .ant-picker {
    height: 50px;
    border-radius: 6px;
    width: 100%;
  }

  position: relative;
  margin-bottom: 15px;

  p {
    margin: 0 0 0.7rem;
    color: var(--texto-color);
    letter-spacing: 0.1rem;
    font-size: var(--font-tamanho);
  }
`;
